import axios from 'axios'
import config from './config'
const URL = `${config.URL}/maintenance/nonconforming`

export async function create (data) {
  const result = await axios.post(`${URL}/create`, data, config.configWithToken())
  return result.data
}

export async function all (page) {
  const result = await axios.get(`${URL}/all/${page}`, config.configWithToken())
  return result.data
}

export async function detail (id) {
  const result = await axios.get(`${URL}/detail/${id}`, config.configWithToken())
  return result.data
}

export async function filter (page) {
  const result = await axios.get(`${URL}/filter/${page}`, config.configWithToken())
  return result.data
}

export async function report (data, type_report) {
  const result = await axios.post(`${URL}/search`, {query: data, type_report}, config.configWithToken())
  return result.data
}

export async function update (id, data) {
  const result = await axios.post(`${URL}/update/${id}`, data, config.configWithToken())
  return result.data
}

export default {
  all,
  filter,
  create,
  detail,
  update,
  report
}
